export const API_SUBSCRIBERS_VIEW_PATH = "/api-subscribers";
export const API_SUBSCRIBER_CREATE_VIEW_PATH = "/api-subscribers/create";
export const API_SUBSCRIBER_DETAIL_VIEW_PATH = "/api-subscribers/:principal";
